import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

export const helpers = createMultiStyleConfigHelpers([
  'basketItemContainer',
  'fullLabel',
  'andCollectAvios',
  'multiplePrices',
  'strikeThroughSale',
  'strikeThroughPrice',
])

// TODO: 'multiplePrices', 'strikeThroughSale', 'strikeThroughPrice' should be used when the basket information includes strikethrough prices.

export const BasketItemPaymentOptionsSelect = helpers.defineMultiStyleConfig({
  baseStyle: {
    basketItemContainer: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: 4,
      height: '100%',
      width: '100%',
      fontSize: 'sm',

      '> label > div': {
        alignSelf: 'start',
      },
    },
    fullLabel: {
      display: 'flex',
      flexDirection: 'column',
      lineHeight: 1.29,
    },
    andCollectAvios: {
      fontSize: 'sm',
    },
    multiplePrices: {
      display: 'flex',
      flexDirection: 'column',
    },
    strikeThroughPrice: {
      textDecoration: 'line-through',
    },
  },
})
